
import {Component, Vue,Prop} from "vue-property-decorator";


@Component
export default class HomeClass extends Vue {
    @Prop({ default: '' }) readonly title!: string;
    @Prop({ default: '' }) readonly des!: string;


}
